import MuiStack from "@mui/material/Stack";

export default function Stack(props) {
  return <MuiStack {...props} />;
}
